import axios from 'axios'

const url = "https://expensewebproject.herokuapp.com/"

export const axiosInstance = axios.create({
    baseURL: url,
    headers: {
            Authorization: localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : null,
            'Content-Type': 'application/json',
            accept: 'application/json'
    }
})